import axios from "axios";

const ENDPOINT_KEY = "inventory";
const ENDPOINT_URI = "/inventory";

export default function useInventoryService() {
  return {
    queryKey: ENDPOINT_KEY,
    updateInventory: async ({ id, payload }) => {
      const response = await axios.put(`${ENDPOINT_URI}/${id}`, payload);
      return response.data.payload;
    },
    
  };
}